import {FormioBase} from "./formiobase";

export class Number extends FormioBase {
  public inputType = "number";
  public title = "Number";
  public icon = "fa fa-hashtag";
  public schema: any = {
    title: "number",
    components: [{
      input: true,
      tableView: true,
      inputType: "number",
      label: "Number",
      key: undefined,
      placeholder: "",
      prefix: "",
      suffix: "",
      defaultValue: "",
      protected: false,
      persistent: true,
      disabled: false,
      notvisible: false,
      totalvisibleinfooter: false,
      allowCalculateOverride: true,
      validate: {
        required: false,
        min: "0",
        max: "99999999",
        step: "any",
        integer: "",
        multiple: "",
        custom: "",
        requiredTotalPercentage: false,
      },
      type: "number",
      tags: [],
      maxValue: "",
      description: "",
      tooltip: "",
      customClass: "ds-number",
    }],
  };
}
